import { ref } from '@vue/composition-api'
import store from '@/store'
import {DialyReportServices}   from './services'

export default function settingForm() {

    const schedule_at = ref("")
    const  emails=ref("");
    const reports=ref([]);
    const allReports=ref([]);


    const createEmailsList=(data)=>{
      
  //console.log(data)
     return data.map((m,index)=>({id:index,name:m}))

    }

    const  createReportsList=(data)=>{
       // data=['sweep','absence','status']

       return data.map((r,index)=>({id:index,name:r.type}))
       //return data.map((r,index)=>({id:index,name:r}))
    }

    const createAllReportsList=()=>{

     const reportsData= store.state.auth.userData.reports;

      //const   reportsData = ['sweep','absence','garden']
       return reportsData.map((element,index) => ({"id":index,"name":element}));

    }

    DialyReportServices.getReportNotifications()
    .then(response => {
        
        emails.value=response.emails.toString();
        reports.value=createReportsList(response.reports)
        schedule_at.value=response.schedule_at
        allReports.value=createAllReportsList()

      

    })
    
    return {
       emails,
        reports,
        schedule_at,
        allReports
       }
}